import React from 'react';
import {
	getDiscount,
	loadStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import styled from 'styled-components';

const MonacoCardDiv = styled.div`
	max-width: 286.5px;
	min-width: 168px;
	cursor: pointer;
	margin-bottom: 20px;
	@media (max-width: 320px) {
		min-width: 142px;
	}
	@media (min-width: 320px) and (max-width: 480px) {
		& > .ff-monaco-card-image {
			min-height: 367px !important;
			min-width: 100% !important;
			max-width: 100% !important;
			& > img {
				min-width: calc(100% - 2px) !important;
				max-width: calc(100% - 2px) !important;
				height: 367px !important;
			}
			&.imageNotAvailable {
				justify-content: center;
				background-color: #f5f5f5;
				border: 1px solid rgba(0, 0, 0, 0.1);
				& > div.placeholder-text {
					color: #898989;
					text-align: center;
					font-family: var(--fontFamily);
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: 18px;
					letter-spacing: 0.4px;
				}
			}
		}
	}

	& > .ff-monaco-card-image {
		display: flex;
		align-items: center;
		border: 1px solid #e5e5e5;
		min-height: 376px;
		position: relative;
		min-width: 252px;
		max-width: 402px;
		&:hover {
			& > img {
				opacity: 0;
				&.hidden {
					opacity: 1;
				}
			}
		}
		& > img {
			min-width: 250px;
			max-width: 400px;
			height: 375px;
			width: 100%;
			object-fit: contain;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			backface-visibility: hidden;
		}

		& > img.hidden {
			opacity: 0;
		}
		&.imageNotAvailable {
			justify-content: center;
			background-color: #f5f5f5;
			border: 1px solid rgba(0, 0, 0, 0.1);
			& > div.placeholder-text {
				color: #898989;
				text-align: center;
				font-family: var(--fontFamily);
				font-size: 12px;
				font-style: normal;
				font-weight: 400;
				line-height: 18px;
				letter-spacing: 0.4px;
				padding: 0 8px;
			}
		}
	}
	& > .ff-monaco-card-details {
		// min-height: 111px;
		text-align: center;
		text-transform: uppercase;
		font-family: Montserrat !important;
		font-size: 14px;
		display: flex;
		flex-direction: column;

		align-items: center;
		& > .monaco-title,
		& > .monaco-header,
		& > .monaco-price {
			max-width: 238px;
			margin-bottom: 4px;
			letter-spacing: 0.2em;
			&.monaco-title {
				margin-top: 20px;
			}
		}
		& > .discount-shown {
			display: flex;
			align-items: center;
			gap: 6px;
			margin-bottom: 4px;
			flex-wrap: wrap;
			justify-content: center;
			& > p:first-child {
				color: var(--color-scale-1, #1c0047);
				max-width: 238px;
				letter-spacing: 0.4px;
				font-weight: 500;
			}
			& > p:nth-child(2) {
				color: var(--black-60, rgba(0, 0, 0, 0.6));
				max-width: 238px;
				letter-spacing: 0.4px;
				text-decoration: line-through;
				font-weight: 400;
			}
			& > p:last-child {
				color: #ff6b35;
				max-width: 238px;
				letter-spacing: 0.4px;
				font-weight: 600;
			}
		}
	}
`;
type Props = {
	title: string;
	header: string;
	price: string;
	mediaType: string;
	mediaLink: string;
	currency: string;
	selectedProduct: boolean;
	imageOnHover: string;
	sale_price?: string;
};
const MonacoCard = ({
	title,
	header,
	price,
	mediaType,
	mediaLink,
	currency,
	selectedProduct,
	imageOnHover,
	sale_price,
}: Props) => {
	return (
		<MonacoCardDiv
			imageOnHover={imageOnHover}
			className={`ff-monaco-cards ${selectedProduct ? 'selected' : ''}`}
		>
			<div
				className={`ff-monaco-card-image ${
					mediaLink && mediaLink.length === 0 ? 'imageNotAvailable' : ''
				}`}
			>
				{mediaType === 'image' && (
					<>
						{mediaLink.length ? (
							<>
								<img src={mediaLink} alt='' />
								{imageOnHover && imageOnHover.length > 0 && (
									<img
										className='hidden'
										src={imageOnHover}
										alt=''
										image-on-hover={imageOnHover}
									/>
								)}
							</>
						) : (
							<div className='placeholder-text'>IMAGE NOT AVAILABLE</div>
						)}
					</>
				)}
				{mediaType === 'video' && <iframe src={mediaLink} title={mediaLink} />}
			</div>
			<div className='ff-monaco-card-details'>
				<p className='monaco-title'>{title}</p>
				{header ? <p className='monaco-header'>{header}</p> : null}

				{Number(price) ? (
					<>
						{loadStateSession('selectedTheme') === 'E-commerce Chat' &&
						Number(sale_price) !== 0 &&
						price > sale_price ? (
							<div className='discount-shown'>
								<p className='monaco-price'>
									{currency}
									{sale_price}
								</p>
								<p className='monaco-price'>
									{currency}
									{price}
								</p>
								<p className='monaco-price'>
									{getDiscount(price, sale_price)}% OFF
								</p>
							</div>
						) : (
							<p className='monaco-price'>
								{currency}
								{price}
							</p>
						)}
					</>
				) : null}
			</div>
		</MonacoCardDiv>
	);
};

export default MonacoCard;
